import { useQuery } from '@tanstack/react-query';
import { getBasicTokenInfo } from '../pricing/useBasicTokenInfo';
export default function useTopTokens(addresses, {
  enabled = true
} = {}) {
  const {
    data,
    isLoading,
    isFetching,
    error
  } = useQuery({
    queryKey: ['fetchTopTokens'],
    queryFn: async () => {
      const promises = Object.values(addresses).map(tokenInfo => {
        return getBasicTokenInfo(tokenInfo.network, tokenInfo.address, true);
      });
      const results = await Promise.all(promises);
      return results.filter(Boolean);
    },
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchInterval: false,
    enabled: !!addresses && Object.values(addresses).length > 0 && enabled
  });
  return {
    data,
    isLoading,
    isFetching,
    error
  };
  // return useMultiTokenData({
  //   tokens: Object.values(addresses).map((tokenInfo: any) => {
  //     return `${tokenInfo.address}:${tokenInfo.network}`
  //   })
  // })
}